export function postMessageBetweenFrames(message: any): void {
  window.parent.postMessage(message, "*");
}
